import {
  VApp,
  VAlert,
  VCard,
  VCardText,
  VCardTitle,
  VCardActions,
  VTabs,
  VTab,
  VAvatar,
  VMenu,
  VList,
  VListGroup,
  VListItem,
  VListItemTitle,
  VBtn,
  VRow,
  VCol,
  VSpacer,
  VTextField,
  VTextarea,
  VSelect,
  VAutocomplete,
  VSwitch,
  VCheckbox,
  VRadioGroup,
  VRadio,
  VPagination,
  VForm,
  VSheet,
  VContainer,
  VDivider,
  VLayout,
  VAppBar,
  VAppBarNavIcon,
  VNavigationDrawer,
  VMain,
  VFooter,
  VIcon,
  VTooltip,
  VWindow,
  VWindowItem,
  VTable,
  VDialog,
  VBadge,
  VProgressLinear,
  VProgressCircular,
  VOverlay,
  VFileInput,
  VCombobox,
} from 'vuetify/components'
import { VDataTableServer } from 'vuetify/labs/VDataTable'
import { VDatePicker } from 'vuetify/labs/VDatePicker'
import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader'

export default {
  VApp,
  VAlert,
  VCard,
  VCardText,
  VCardTitle,
  VCardActions,
  VTabs,
  VTab,
  VAvatar,
  VForm,
  VMenu,
  VList,
  VListGroup,
  VListItem,
  VListItemTitle,
  VBtn,
  VRow,
  VCol,
  VSpacer,
  VTextField,
  VTextarea,
  VSelect,
  VAutocomplete,
  VSwitch,
  VCheckbox,
  VRadioGroup,
  VRadio,
  VPagination,
  VContainer,
  VDivider,
  VSheet,
  VLayout,
  VAppBar,
  VAppBarNavIcon,
  VNavigationDrawer,
  VMain,
  VFooter,
  VIcon,
  VTooltip,
  VDatePicker,
  VWindow,
  VWindowItem,
  VTable,
  VSkeletonLoader,
  VDialog,
  VBadge,
  VProgressLinear,
  VProgressCircular,
  VOverlay,
  VDataTableServer,
  VFileInput,
  VCombobox,
}
